import { StatusCodes } from 'http-status-codes';
import React, { Fragment } from 'react';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css';
import { Controller, useForm } from 'react-hook-form';
import { toastr } from 'react-redux-toastr';
import api from '../../../api';
import RemoteDataDropDown from '../../../components/dropdown/RemoteDataDropDown';
import ErrorMessage from '../../../components/text/ErrorMessage';
import { ApiResponse, ICancelReason } from '../../../core';

interface IEventCancelFormProps {
  onCancel: () => void;
  onSuccess: () => void;
  eventId: string;
}

export const EventCancelForm: React.FunctionComponent<IEventCancelFormProps> = (
  props
) => {
  const { control, handleSubmit, errors } = useForm<IEventCancelModel>({
    reValidateMode: 'onChange',
    mode: 'onSubmit',
  });
  const onSubmit = async (data: IEventCancelModel) => {
    try {
      const response: ApiResponse<any> = await api.lead.cancelEvent(
        props.eventId,
        data
      );
      if (response.status === StatusCodes.OK) {
        toastr.success('Success', 'Event cancelled successfully');
        props.onSuccess();
      } else {
        toastr.error('Error', 'Unable to cancel the event');
      }
    } catch (err) {
      toastr.error(
        'Error',
        (err as any).response?.data?.data?.message ||
          'Something went wrong while cancel the event'
      );
    }
  };
  const loadCancelReasons = async () => {
    const response: ApiResponse<
      ICancelReason[]
    > = await api.lead.getCancellationReasons();
    return response.data;
  };
  return (
    <div className="container-fluid p-4 popover-style popover-style2 position-relative">
      <form id={'activity-form'} onSubmit={handleSubmit(onSubmit)}>
        <div>
          <div className="font-normal font-weight-semibold mb-2 pb-2">
            Appointment Cancellation
          </div>
          <div className="form-group font-weight-semibold mb-4">
            <label htmlFor="" className="font-sm text-uppercase">
              Reason<span className="text-danger">*</span>
            </label>

            <Controller
              control={control}
              rules={{ required: true }}
              name="cancellationReason"
              render={({ onChange, value, name }) => (
                <RemoteDataDropDown
                  loadData={loadCancelReasons}
                  textField="reason"
                  valueField="reason"
                  onChange={(val) => {
                    onChange(val.reason);
                  }}
                  placeholder="Select Reason"
                ></RemoteDataDropDown>
              )}
            />

            {errors.cancellationReason && (
              <ErrorMessage>Please select reason</ErrorMessage>
            )}
          </div>
          <div className="form-group mb-3">
            <Controller
              control={control}
              name="sendEmail"
              defaultValue={false}
              render={({ onChange, value, name }) => (
                <Fragment>
                  <input
                    onChange={(val) => {
                      const currentValue = value ?? false;
                      onChange(!currentValue);
                    }}
                    type="checkbox"
                    name=""
                    id="sendconfirmation"
                  />
                  <label htmlFor="sendconfirmation">
                    Send confirmation e-mail to client
                  </label>
                </Fragment>
              )}
            />
            {errors.sendEmail && <ErrorMessage>Send</ErrorMessage>}
          </div>
          <div className="form-group mb-3">
            <Controller
              control={control}
              name="sendSMS"
              defaultValue={false}
              render={({ onChange, value, name }) => (
                <Fragment>
                  <input
                    onChange={(val) => {
                      const currentValue = value ?? false;
                      onChange(!currentValue);
                    }}
                    type="checkbox"
                    name=""
                    id="sendsms"
                  />
                  <label htmlFor="sendsms">
                    Send confirmation sms to client
                  </label>
                </Fragment>
              )}
            />
            {errors.sendSMS && <ErrorMessage>Send</ErrorMessage>}
          </div>

          <div className="form-group font-weight-semibold mb-4">
            <label htmlFor="" className="font-sm text-uppercase">
              Your note to the client<span className="text-danger">*</span>
            </label>

            <Controller
              control={control}
              rules={{ required: true }}
              name="cancellationNote"
              render={({ onChange, value, name }) => (
                <textarea
                  className="form-control rounded-sm font-weight-semibold"
                  onChange={onChange}
                  style={{ height: '87px' }}
                  name=""
                  id=""
                />
              )}
            />
            {errors.cancellationNote && (
              <ErrorMessage>Note is required</ErrorMessage>
            )}
          </div>
          <div className="text-right">
            <button
              onClick={() => {
                if (props.onCancel) {
                  props.onCancel();
                }
              }}
              className="btn btn-outline-dark py-2 font-weight-semibold font-normal px-4 mr-1"
            >
              Cancel
            </button>
            <button
              type="submit"
              form="activity-form"
              className="btn btn-primary py-2 font-weight-semibold font-normal"
            >
              Save
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export interface IEventCancelModel {
  cancellationReason: string;
  sendEmail: boolean;
  sendSMS: boolean;
  cancellationNote: string;
}
